export class PosicionCerraduraModel {
    idsCerraduras: number[] = [];
    empresa: number;
    tipoUpdate: number = 1;

    constructor(idsCerraduras: number[], empresa: number) {
        this.idsCerraduras = idsCerraduras;
        this.empresa = empresa;
    }
}